<template>
    <div class="hot-question-wrapper">
        <component
            :is="item.wtType"
            v-for="item in data.items"
            :key="item.uId"
            :count="data.items.length"
            :data="item"
            :parentUId="data.uId"
            @deleteItem="deleteItem"
        ></component>
        <div class="item-add-btn" v-show="isShowAdd" @click="addItem">
            <i class="icon-add"></i>
        </div>
    </div>
</template>

<script>
import HotEditItem from "./hotItem/HotEditItem";

export default {
    name: "HotRecommend",
    props: ["data"],
    components: {
        HotEditItem
    },
    computed: {
        isShowAdd() {
            return this.data.items.length < 4;
        }
    },
    methods: {
        addItem() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContent",
                widget: {
                    uId: this.data.uId,
                    hotType: "HotEditItem"
                }
            });
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "addContentItem",
                widget: {
                    uId: this.data.uId,
                    item: {
                        type: "HotEditItem"
                    }
                }
            });
        },
        deleteItem(itemId) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "deleteContentItem",
                widget: {
                    uId: this.data.uId,
                    item: {
                        uId: itemId
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.hot-question-wrapper {
    position: relative;
    padding: 14px;
    border-radius: 8px;
    background: #f2f7fb;
    .item-add-btn {
        width: 76px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #d8e4f0;
        border-radius: 20px;
        cursor: pointer;
        text-align: center;
        line-height: 30px;
        margin-top: 5px;
        .icon-add {
            display: inline-block;
            width: 14px;
            height: 14px;
            vertical-align: middle;
            background: url($zhijiStaticImagePath+"class-spr.png");
            background-position: -297px -1px;
        }
    }
}
</style>
